export default "__VITE_ASSET__ft1at$Ae__"